import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {PageTitleLayoutComponent} from "../../../components/page-title-layout/page-title-layout.component";
import {ParagraphsComponent} from "../../../components/paragraphs/paragraphs.component";
import {LotteriesAndFooterComponent} from "../../../components/lotteries-and-footer/lotteries-and-footer.component";
import {UserService} from "../../../services/user.service";

@Component({
  selector: 'homey-about-us-page',
  imports: [
    PageTitleLayoutComponent,
    ParagraphsComponent,
    LotteriesAndFooterComponent
  ],
  templateUrl: './about-us-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutUsPageComponent {
  protected readonly user = inject(UserService).user
}
